import { useTranslation } from 'react-i18next';

/** i18n hazır olduktan sonra (Suspense vb.) */
export default function PageLoader() {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white font-roboto"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="w-12 h-12 border-4 border-luminary-gold/30 border-t-luminary-gold rounded-full animate-spin"
          aria-hidden="true"
        />
        <p className="text-a11y-body font-medium">{t('a11y.loading')}</p>
      </div>
    </div>
  );
}

/** bootstrapLocalization öncesi — i18n henüz yok */
export function BootstrapPageLoader() {
  const label =
    typeof document !== 'undefined' && document.documentElement.lang === 'en'
      ? 'Loading…'
      : 'Yükleniyor…';

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white font-roboto"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="w-12 h-12 border-4 border-luminary-gold/30 border-t-luminary-gold rounded-full animate-spin"
          aria-hidden="true"
        />
        <p className="text-a11y-body font-medium">{label}</p>
      </div>
    </div>
  );
}
